import { getAxiosInstance } from '../../react/utils/networkUtil';
import {
  CollectDashboardData,
  CollectDashboardFilters,
  CollectDashboardOverview,
  CollectFormProgress,
  CollectStaffPerformance,
  CollectErrorHeatmap,
  CollectRecentError,
} from '../models/CollectDashboard';

// Main dashboard API endpoints
export const remote_getCollectDashboardOverview = async (
  filters?: CollectDashboardFilters,
): Promise<CollectDashboardOverview> => {
  const response = await getAxiosInstance().get('/api/collect-dashboard/overview', {
    params: filters,
  });
  return response.data; // Return the data directly since controller returns raw data
};

export const remote_getCollectDashboardFormsProgress = async (
  filters?: CollectDashboardFilters,
): Promise<CollectFormProgress[]> => {
  const response = await getAxiosInstance().get('/api/collect-dashboard/forms-progress', {
    params: filters,
  });
  return response.data; // Return the data directly since controller returns raw data
};

export const remote_getCollectDashboardStaffPerformance = async (
  filters?: CollectDashboardFilters,
): Promise<CollectStaffPerformance[]> => {
  const response = await getAxiosInstance().get('/api/collect-dashboard/staff-performance', {
    params: filters,
  });
  return response.data; // Return the data directly since controller returns raw data
};

export const remote_getCollectDashboardErrorHeatmap = async (
  filters?: CollectDashboardFilters,
): Promise<CollectErrorHeatmap> => {
  const response = await getAxiosInstance().get('/api/collect-dashboard/errors-heatmap', {
    params: filters,
  });
  return response.data; // Return the data directly since controller returns raw data
};

export const remote_getCollectDashboardRecentErrors = async (
  filters?: CollectDashboardFilters,
): Promise<CollectRecentError[]> => {
  const response = await getAxiosInstance().get('/api/collect-dashboard/recent-errors', {
    params: filters,
  });
  return response.data; // Return the data directly since controller returns raw data
};

// Combined dashboard data endpoint
export const remote_getCollectDashboardData = async (
  filters?: CollectDashboardFilters,
): Promise<CollectDashboardData> => {
  const response = await getAxiosInstance().get('/api/collect-dashboard', {
    params: filters,
  });
  return response.data; // Return the data directly since controller returns raw data
};

// Refresh dashboard data endpoint
export const remote_refreshCollectDashboardData = async (): Promise<CollectDashboardData> => {
  const response = await getAxiosInstance().post('/api/collect-dashboard/refresh');
  return response.data; // Return the data directly since controller returns raw data
};

// Dashboard API collection
export const CollectDashboardAPIs = {
  remote_getCollectDashboardOverview,
  remote_getCollectDashboardFormsProgress,
  remote_getCollectDashboardStaffPerformance,
  remote_getCollectDashboardErrorHeatmap,
  remote_getCollectDashboardRecentErrors,
  remote_getCollectDashboardData,
  remote_refreshCollectDashboardData,
};
